import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'apps/new-web/views/components/i18n';
import BaseComponent from 'apps/new-web/views/component';
import { connect } from 'react-redux';
import createLayout from 'apps/new-web/views/pages/create-layout';
import HeaderNav from './components/header-nav';
import DesktopHero from './components/desktop-hero';
import StatisticsBox from './components/statistics-box';
import MobileHero from './components/mobile-hero';
import OverviewBox from './components/overview-box';
import GenericModal from 'apps/new-web/views/components/generic-modal';
import DatePicker from 'react-datepicker';
import muiConfig from 'apps/new-web/views/pages/settings/mui-config';
import MuiSnackbar from '@material-ui/core/Snackbar';
import PrimaryButton from 'apps/new-web/views/components/primary-button';
import * as ScheduleHelper from './schedule-helper';

class PureWorkoutView extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
      startDate: new Date(),
    };
  };

  static stringSanitization(str) {
    return str.replace(/"/g, '&quote;');
  };

  static getAdditionalHeadTags(props) {
    return `
      <meta name="description" content="${I18n.translate('Check out my workout on iFIT', { ifit: 'iFIT' }, 'Invites user to view another iFIT member‘s completed workout program.')}" />
      <meta name="og:image" content="${props.sharedWorkout.imageUrl}" />
      <meta name="og:description" content="${I18n.translate('Check out my workout on iFIT', { ifit: 'iFIT' }, 'Invites user to view another iFIT member‘s completed workout program.')}" />
      <meta name="og:title" content="${this.stringSanitization(props.sharedWorkout.workout.title)}" />
      <meta name="og:type" content="website" />
      <meta name="twitter:image", content="${props.sharedWorkout.imageUrl}" />
      <meta name="twitter:title", content="${this.stringSanitization(props.sharedWorkout.workout.title)}" />
      <meta name="twitter:description", content="${I18n.translate('Check out my workout on iFIT', { ifit: 'iFIT' }, 'Invites user to view another iFIT member‘s completed workout program.')}" />
      <meta name="twitter:card", content="summary_large_image" />
      <meta name="twitter:site", content="@ifit" />
    `;
  }

  static getAdditionalBodyTags() {
    return '';
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const key = params.get('show');
    this.setState({
      isModalOpen: key !== null
    });
  }

  showSnackbar(message) {
    this.setState({
      showSnackbar: true,
      snackbarMessage: message
    });
  }

  hideSnackBar() {
    this.setState({ showSnackbar: false });
  }

  toggleModal() {
    this.setState({
      isModalOpen: !this.state.isModalOpen
    });
  };

  closeModal() {
    this.setState({
      isModalOpen: false
    });
  };

  handleChange(date) {
    this.setState({
      startDate: date
    }, () => {
      const { _id: workoutId } = this.props.sharedWorkout.workout;
      const that = this;
      ScheduleHelper.scheduleEvent(workoutId, date).then(() => {
        that.showSnackbar(<I18n desc="Prompt letting a user know their workout has been scheduled.">Your workout has been scheduled.</I18n>);
        that.toggleModal();
      }).catch( (error) => {
        that.showSnackbar(<I18n desc="Prompt letting a user know there was an error scheduling their workout.">There was an error scheduling the workout.</I18n>);
        that.toggleModal();
        console.log(`Workout scheduling error: ${error}`); // eslint-disable-line no-console
      });
    });
  }

  render() {
    const { user } = this.props;
    const { mediaType } = this.props.layout;

    return (
      <div className="share-workout-view-page">
        <section>
          <HeaderNav />
          {mediaType === 'mobile'
            ? <React.Fragment>
              <MobileHero
                mediaType={ mediaType }
              />
              <div className="overview-section">
                <OverviewBox toggleModal={ this.toggleModal } />
              </div>
            </React.Fragment>
            : <React.Fragment>
              <DesktopHero />
              <StatisticsBox toggleModal={ this.toggleModal } />
            </React.Fragment>
          }
          <MuiSnackbar
            { ...muiConfig.snackbar }
            className="snackbar"
            severity="success"
            open={ this.state.showSnackbar }
            message={ this.state.snackbarMessage || '' }
            onClose={ this.hideSnackBar }
            autoHideDuration={ 5000 }
            style={{
              ...muiConfig.snackbar.style,
              top: '50%'
            }}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          />
          <GenericModal
            isOpen={ this.state.isModalOpen }
            title={ 'Schedule Your Workout' }
            containerClass={ user && user.status === 'expired' ? '' : 'calendar' }
            handleModalClose={ this.closeModal }
            closeX
            closeXText="Close Calendar"
          >
            {user && user.status === 'expired' ?
              <React.Fragment>
                <h2 className="expired-modal-header"><I18n desc="Prompt letting a user know their account has expired." args={{ ifit: 'iFIT' }}>Your [ifit] account has expired.</I18n></h2>
                <p className="expired-modal-copy"><I18n desc="Prompt letting a user know they care not able to schedule a workout." >You cannot add this workout to your calendar.</I18n></p>
                <PrimaryButton
                  href="/renewal"
                  label={ I18n.translate('Please renew your account', 'Button inviting user to renew their iFIT account.') }
                />
              </React.Fragment> :
              <DatePicker
                selected={ this.state.startDate }
                onChange={ this.handleChange }
                minDate={ new Date() }
                inline
              />
            }
          </GenericModal>
        </section>
      </div>
    );
  }
}

PureWorkoutView.propTypes = {
  workout: PropTypes.object,
  layout: PropTypes.object,
  user: PropTypes.object
};

const WorkoutView = connect((state) => {
  return {
    sharedWorkout: state.sharedWorkout,
    layout: state.layout,
    user: state.user
  };
})(PureWorkoutView);

export default createLayout(WorkoutView);